module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0062.jpg?v=5ef45c18";